import {
  useFormatFieldValue,
  type FieldFormat,
} from "@coworker/apprestructured/src/task-management/hooks/useFormatFieldValue";

export type FormatStep = { value: string; format?: FieldFormat };

// Each step formats its own value, receiving the previous step's output as an interpolation param.
export function useFormatRecursiveSelfValue() {
  const formatFieldValue = useFormatFieldValue();

  return (steps: FormatStep[]): string => {
    return steps.reduce<string>(
      (prev, step) => formatFieldValue(step.value, step.format, prev),
      ""
    );
  };
}
